module.exports = {
  locales: ["it", "en"],
  defaultLocale: "it",
  pages: {
    "*": [
      "error-feedback",
      "auth-layout",
      "link-to-login",
      "ops",
      "403",
      "404",
      "rules",
      "cookie-policy",
    ],
    "/": ["login", "two-factors"],
    "/profile": [
      "profile",
      "avatar",
      "file-uploader",
      "form-password-profile",
      "form-profile",
      "password-confirm",
      "password-form",
    ],
    "/cookie-policy": ["cookie-policy"],
    "/password/recovery": ["recovery"],
    "/password/reset": ["reset", "password-form", "password-confirm"],
    "/registration/[token]": [
      "registration",
      "password-form",
      "password-confirm",
    ],
  },
};
